import { apiFetchJson } from './dispatchClient';
import { debug } from '../lib/debug';

/**
 * 車両タイプの優先度を更新
 * @param id - 車両タイプID
 * @param priority - 新しい優先度
 * @returns 更新後の車両タイプデータ
 */
export const updateVehicleTypePriority = async (id: number | string, priority: number): Promise<any> => {
    if (!id) {
        throw new Error('Vehicle Type ID is required for update');
    }

    const payload = {
        id: Number(id),
        vehicle_type_priority: Number(priority),
    };

    debug.log('vehicleTypeService', 'updateVehicleTypePriority payload:', payload);

    const response = await apiFetchJson('dispatch/vehicle-types/update', {
        method: 'POST',
        body: JSON.stringify(payload),
    });

    debug.log('vehicleTypeService', 'updateVehicleTypePriority response:', response);

    return response;
};
